<div class="modalAlert">
  <i *ngIf="info.icon === 'success'" class="iconwhite-check-5 modalAlert-icon"></i>
  <i *ngIf="info.icon === 'error'" class="iconwhite-no-stopping modalAlert-icon"></i>
  <i *ngIf="info.icon === 'warning'" class="iconwhite-exclamation3 modalAlert-icon"></i>
  <h3 class="modalAlert-title">{{info.title }}</h3>
  <p *ngIf="messageString != '' " class="modalAlert-message">{{ messageString}}</p>
  <div class="modalAlert-messageAlert" *ngIf="info.alert">
    <i class="iconwhite-exclamation3"></i>
    <p>{{info.alert}}</p>
  </div>
  <div *ngIf="messageArray.length > 0 ">
      <p *ngFor="let item of messageArray" class="modalAlert-message" style="margin-bottom: 4px;" >{{ item }}</p>
  </div>
  

  <div class="modalAlert-buttons">
    <button class="btn btnAkthaPrimary-outline" (click)="dialogRef.close( false )"   *ngIf="info.type === 2" type="button" >Cancelar</button>
    <button class="btn btnAkthaPrimary" (click)="dialogRef.close( true )"   type="button">Aceptar</button>
  </div>
</div>